






















































import axios from 'axios';

import EventBus from '@/eventBus';
import CoEditor from '@/components/Molecules/co-editor/CoEditor.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';

export default {
    name: 'LegalAgreements',
    components: {
        CoHeadline,
        CoText,
        CoEditor,
        CoButton,
        CoCheckbox,
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        getUrl: {
            type: String,
            default: null,
        },
        postUrl: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            agreement: {
                Content: '',
                RequestApproval: false,
            },
            loading: false,
            createdAt: null,
            loadedContent: null,
            renderkey: 0,
        };
    },
    mounted() {
        this.getAgreement();
    },
    methods: {
        hasHistory() {
            return window.history.length > 2;
        },
        saveAgreement() {
            if (!this.postUrl) {
                console.warn('No postUrl provided for LegalAgreements component');
            }
            this.loading = true;
            axios({
                method: 'POST',
                url: this.postUrl,
                data: this.agreement,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.agreement = response?.data || {};
                    this.loadedContent = response?.data?.Content || '';
                    this.createdAt = response?.data?.CreatedAt || null;

                    EventBus.$emit('INFO', {
                        Message: 'New version is saved',
                        Details: '',
                    });
                })
                .catch((error) => {
                    this.loading = false;
                    if (error?.response?.status === 404) {
                        // do nothing
                    } else {
                        const msg = {
                            Message: 'Failed to save agreement',
                            Details: '',
                        };
                        EventBus.$emit('ERROR', msg);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getAgreement() {
            if (!this.getUrl) {
                console.warn('No getUrl provided for LegalAgreements component');
                return;
            }
            this.loading = true;
            axios({
                method: 'GET',
                url: this.getUrl,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.agreement = response?.data || {};
                    this.loadedContent = response?.data?.Content || '';
                    this.createdAt = response?.data?.CreatedAt || null;
                })
                .catch((error) => {
                    if (error?.response?.status === 404) {
                        // do nothing
                    } else {
                        const msg = {
                            Message: 'Failed to get agreement',
                            Details: '',
                        };
                        EventBus.$emit('ERROR', msg);
                    }
                })
                .finally(() => {
                    this.loading = false;
                    // make sure editor refreshes with loaded content
                    this.renderkey += 1;
                });
        },
    },
};
